import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { Button } from '@driftt/dds'
import {
  Div,
  Footer,
  H3,
  Input,
  Label,
  Modal,
  P,
  FingerGunToolTip
} from '@driftt/tide-core'

import './style.css'

class ExportEmailModal extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      email: '',
      emailError: ''
    }
  }

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  handleEmailChange = (event) => {
    this.setState({ 
      email: event.target.value,
      emailError: ''
    })
  }

  handleConfirm = () => {
    const { email } = this.state
    const { onConfirm } = this.props

    if (!email.trim()) {
      this.setState({ emailError: 'Email is required' })
      return
    }

    if (!this.validateEmail(email)) {
      this.setState({ emailError: 'Please enter a valid email address' })
      return
    }

    onConfirm(email)
    this.setState({ email: '', emailError: '' })
  }

  handleClose = () => {
    const { onClose } = this.props
    this.setState({ email: '', emailError: '' })
    onClose()
  }

  render() {
    const { open } = this.props
    const { email, emailError } = this.state

    return (
      <Modal 
        open={open}
        onClose={this.handleClose}
        type="default"
        size="small"
      >
        <H3>Email CSV</H3>
        <Div className="export-email-modal--input-container">
          <Label htmlFor="recipient-email">Email address</Label>
          <Input
            id="recipient-email"
            type="email"
            value={email}
            onChange={this.handleEmailChange}
            placeholder="youremail@salesloft.com"
            error={!!emailError}
          />
          {emailError && (
            <P className="export-email-modal--error">{emailError}</P>
          )}
          <Div className="export-email-modal--tip">
            <FingerGunToolTip value="Tip: Enter a valid Salesloft email or a customer email associated with this org." />
          </Div>
        </Div>
        <Footer>
          <Button variant="primary" onClick={this.handleConfirm}>
            Email CSV
          </Button>
          <Button variant="secondary" onClick={this.handleClose}>
            Cancel
          </Button>
        </Footer>
      </Modal>
    )
  }
}

ExportEmailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ExportEmailModal
